import { API_ENDPOINTS } from "@/shared/constants"
import { httpClient } from "@/shared/services/http"

export interface CreateUserPayload {
  identifier: string
  identifier_type: 'email' | 'mobile'
  password: string
}

export const usersApi = {
  /**
   * Get all users
   */
  getAllUsers: async (isActive: boolean): Promise<any> => {
    const response = await httpClient.get<any>(API_ENDPOINTS.USERS.GET_USERS + `${isActive}`)
    const data = response.data?.data ?? []

    return data.map((user: any) => ({
      id: user.id || user.user_id || '',
      email: user.email || user.identifier || '',
      mobile: user.mobile || user.phone || '',
      name: user.name || user.full_name || '',
      role: user.role || user.user_role || '',
      dateCreated: user.created_at || user.createdDate || '',
      created_at: user.created_at || user.createdDate || '',
      deleted_at: user.deleted_at || user.deletedDate || '',
      is_active: user.is_active ?? user.active ?? false,
      status: user.is_active || user.active ? 'Active' : 'Inactive',
    }))
  },

  /**
   * Create a new user via auth signup endpoint
   */
  createUser: async (payload: CreateUserPayload): Promise<any> => {
    const response = await httpClient.post<any>(API_ENDPOINTS.AUTH.SIGNUP, payload)
    return response.data
  },

  toggleActiveUser: async (userId: string | number): Promise<any> => {
    const response = await httpClient.patch<any>(API_ENDPOINTS.USERS.TOGGLE_ACTIVE(userId))
    return response.data
  },
}
